var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1616_89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 28.962C33.411 28.962 30.942 28.398 28.665 27.285C28.308 27.114 27.894 27.087 27.516 27.216C27.138 27.348 26.829 27.624 26.655 27.981L25.575 30.216C22.335 28.356 19.647 25.665 17.784 22.425L20.022 21.345C20.382 21.171 20.655 20.862 20.787 20.484C20.916 20.106 20.892 19.692 20.718 19.335C19.602 17.061 19.038 14.592 19.038 12C19.038 11.172 18.366 10.5 17.538 10.5H12C11.172 10.5 10.5 11.172 10.5 12C10.5 26.061 21.939 37.5 36 37.5C36.828 37.5 37.5 36.828 37.5 36V30.462C37.5 29.634 36.828 28.962 36 28.962Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1616_89"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.8540d72933ab13a5382fb705882e2eb1.svg";
export { ForwardRef as ReactComponent };